import React, { useState } from 'react';
import {
  ShowBase,
  Datagrid,
  useShowContext,
  ReferenceManyField,
  TextField,
  DateField,
  Pagination,
  useRedirect,
} from 'react-admin'; 
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';
import { Route, useLocation } from 'react-router';

import { BooleanField } from '../publications/BooleanField';
import { PublicationShow } from '../publications/PublicationShow';
import { ShowButton, ActionButton } from '../publications/PublicationList';

import { Avatar } from './Avatar';
import { UserAside } from './UserAside';
import { UserEdit } from './UserEdit';

export const UserShow = (props) => {
  return (
    <>
      <ShowBase {...props}>
        <UserShowContent />
      </ShowBase>
      <Route path="/users/:userId/show/:videoId">
        {({ match }) =>
          !!match ? (
            <PublicationShow open={!!match} id={match?.params?.videoId} />
          ) : null
        }
      </Route>
    </>
  );
};

const UserShowContent = () => {
  const { record, loaded } = useShowContext();
  const [show, setShow] = useState(false);

  if (!loaded || !record) return null;
  return (
    <>
      <UserEdit record={record} open={show} onClose={() => setShow(false)} />
      <Box mt={2} display="flex">
        <Box flex="1">
          <Card>
            <CardContent>
              <Box display="flex" mb={3}>
                <Avatar record={record} />
                <Box ml={2} flex="1">
                  <Typography variant="h5">
                    {record.full_name}
                  </Typography>
                  <Typography variant="body2">
                    {record.nick_name}
                  </Typography>
                </Box>
              </Box>

              <ReferenceManyField
                reference="publications"
                target="user_id"
                filter={{is_approved: 'all'}}
                perPage={10}
                pagination={<Pagination />}
              >
                <UserPublicationsContent />
              </ReferenceManyField>
            </CardContent>
          </Card>
        </Box>
        <UserAside record={record} onButtonClick={() => {setShow(true)}} />
      </Box>
    </>
  );
};

const UserPublicationsContent = () => {
  const redirect = useRedirect();
  const { pathname } = useLocation();

  const onShowClick = (id) => {
    redirect(`${pathname}/${id}`);
  }

  return (
    <Datagrid>
      <TextField source="id" />
      <DateField source="created_at" label="Data de criação" />
      <BooleanField source="is_approved" label="Status" />
      <ActionButton />
      <ActionButton variant="block" />
      <ShowButton onClick={onShowClick} />
    </Datagrid>
  );
}